import { HttpClient } from '@hot-club-http/client/http-client'

import { APP_NAME_VERSION, APP_SPACE_HOT_HTTP_INSTANCES } from '@space-shell/config/request'

const headers = { 'X-APP-NAME': APP_NAME_VERSION }

HttpClient.createQueryClient() // MF running in standalone mode
HttpClient.createInstance(
  APP_SPACE_HOT_HTTP_INSTANCES.API_CONTENT_GATEWAY,
  process.env.BASE_URL as string,
  {
    headers
  }
)

HttpClient.createInstance(
  APP_SPACE_HOT_HTTP_INSTANCES.API_SPARKLE,
  process.env.API_SPARKLE as string,
  {
    headers
  }
)

HttpClient.createInstance(
  APP_SPACE_HOT_HTTP_INSTANCES.API_SPARKLE_SECURITY,
  process.env.API_SPARKLE_SECURITY as string,
  {
    headers
  }
)

HttpClient.createInstance(
  APP_SPACE_HOT_HTTP_INSTANCES.API_HOTMART_AI,
  process.env.API_HOTMART_AI as string,
  {
    headers
  }
)

HttpClient.createInstance(
  APP_SPACE_HOT_HTTP_INSTANCES.API_HOTMART_TUTOR,
  process.env.API_HOTMART_TUTOR as string,
  {
    headers
  }
)

HttpClient.createInstance(
  APP_SPACE_HOT_HTTP_INSTANCES.API_COMMUNITY_GATEWAY,
  process.env.API_COMMUNITY_GATEWAY as string,
  {
    headers
  }
)

HttpClient.createInstance(
  APP_SPACE_HOT_HTTP_INSTANCES.API_DISPLAY_MARKETPLACE,
  process.env.API_DISPLAY_MARKETPLACE as string,
  {
    headers
  }
)

HttpClient.createInstance(
  APP_SPACE_HOT_HTTP_INSTANCES.API_CONSUMPTION_GATEWAY,
  process.env.API_CONSUMPTION as string,
  {
    headers
  }
)

HttpClient.createInstance(APP_SPACE_HOT_HTTP_INSTANCES.API_ASK, process.env.API_ASK as string, {
  headers
})

HttpClient.createInstance(APP_SPACE_HOT_HTTP_INSTANCES.API_IP, process.env.API_IP as string, {
  headers
})

HttpClient.createInstance(
  APP_SPACE_HOT_HTTP_INSTANCES.API_CHECKOUT_GATEWAY,
  process.env.API_CHECKOUT as string,
  {
    headers
  }
)
